/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDevice } from 'app/shared/model/device.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IHospitalManager } from 'app/shared/model/hospital-manager.model';
import { ChargeType } from 'app/shared/model/enumerations/charge-type.model';
import { EquipmentType } from 'app/shared/model/enumerations/equipment-type.model';

export interface IEquipmentIP {
  id?: string;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  charge?: number | null;
  chargeType?: keyof typeof ChargeType | null;
  allotted?: boolean | null;
  supended?: boolean | null;
  expiryDate?: number | null;
  maxUses?: number | null;
  notes?: string | null;
  deviceNo?: string | null;
  deviceName?: string | null;
  mfdDate?: number;
  dateSupended?: number | null;
  reasonSupended?: string | null;
  maintainanceCycle?: number | null;
  lastMaintenanceDate?: number | null;
  tax?: string | null;
  underMaintainance?: boolean | null;
  equipmentType?: keyof typeof EquipmentType | null;
  location?: string | null;
  device?: IDevice | null;
  hospital?: IHospital;
  addedBy?: IHospitalManager;
  modifiedBy?: IHospitalManager | null;
}

export const defaultValue: Readonly<IEquipmentIP> = {
  active: false,
  allotted: false,
  supended: false,
  underMaintainance: false,
};
